import { prepareFormData } from "@/store/utils/formDataHelper";
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import { IClients, IClientsListItem } from "@/entity/clients/clients.types";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import { ClientGeneralRequestType } from "@/form/clientGeneral/clientGeneral.types";
import { ResponseDataType } from "@/form/form.types";
import { IStoreReady } from "@/store/lib/storeSupport";
import { PaymentAccount } from "@/entity/clients/Accounts/account.types";
@Module({
    namespaced: true,
    name: "clients",
    store,
    dynamic: true,
})
class ClientsModule extends VuexModule implements IStoreReady {
    clients: IClients | null = null;
    client: IClientsListItem | null = null;
    DebtData = {};

    clientLoaded = false;
    clientsLoaded = false;
    ready = false;

    @Mutation
    async clearItems() {
        this.clients = null;
    }

    @Mutation
    async clientDebtData(): Promise<void> {
        let paid = 0,
            sum = 0;

        if (this.client && this.client.visits) {
            this.client?.visits.map(async (visit: any) => {
                if (visit["order"] && visit["order"]["paid"]) {
                    paid = paid + Number(visit["order"]["paid"]);
                    sum = sum + Number(visit["order"]["sum"]);
                }
            });
        }
        this.DebtData = { paid: paid, sum: sum, debit: sum - paid };
    }

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ clients: IClients; clientsLoaded: boolean }> {
        let clientsLoaded = false;

        const clients = await store.$repository.clients.fetchAll(prepareFormData(data));
        if (clients) {
            clientsLoaded = true;
        }
        return { clients, clientsLoaded };
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ client: IClientsListItem; clientLoaded: boolean }> {

        let clientLoaded = false;
        const client = await store.$repository.clients.fetchData(data);

        if (client) {
            clientLoaded = true;

            for (const field of ['source', 'category'] as const) {
                let values: unknown = client[field];
                if (typeof values === 'string') {
                    try { values = JSON.parse(values); } catch { values = []; }
                }
                client[field] = Array.isArray(values) ? Array.from(new Set(values.map(Number).filter(value => Number.isSafeInteger(value) && value > 0))) : [];
            }
        }
        return { client, clientLoaded };
    }
    @Action({ rawError: true })
    async create(data: ClientGeneralRequestType): Promise<boolean> {
        return await store.$repository.clients.create(data);
    }
    @Action({ rawError: true })
    async update(data: ClientGeneralRequestType): Promise<ResponseDataType> {
        return await store.$repository.clients.update(data);
    }
    @Action({ rawError: true })
    async delete(data: { id: number }): Promise<ResponseDataType> {
        return await store.$repository.clients.delete(data);
    }

    @Action({ rawError: true })
    async createPaymentAccount(data: PaymentAccount): Promise<ResponseDataType> {
        return await store.$repository.clients.createPaymentAccount(data);
    }

    @Action({ rawError: true })
    async refillPaymentAccount(data: PaymentAccount): Promise<ResponseDataType> {
        return await store.$repository.clients.refillPaymentAccount(data);
    }

    @Mutation
    setReady(st: boolean) {
        this.ready = st;
    }
}

export const ClientsStore = getModule(ClientsModule);
